<template>
  <div>
    <v-row class="remove-print">
      <v-col cols="12" md="12" sm="12">
        <v-text-field
          v-model="formData.date"
          type="date"
          label="Tanggal"
          outlined
          clearable
          dense
          @keydown.enter="fetchData"
        ></v-text-field>
      </v-col>
    </v-row>

    <v-row
      class="fill-height"
      align-content="center"
      justify="center"
      v-if="state.loading"
    >
      <v-col class="text-subtitle-1 text-center" cols="12">
        Loading ...
      </v-col>
      <v-col cols="6">
        <v-progress-linear
          color="deep-purple accent-4"
          indeterminate
          rounded
          height="6"
        ></v-progress-linear>
      </v-col>
    </v-row>

    <h3>Preview</h3>
    <p v-if="state.noData">No Data</p>

    <main
      class="report"
      v-if="!state.noData && !state.loading"
      id="section-print"
    >
      <div class="header">
        <h2>LAPORAN KEJADIAN HARIAN</h2>
        <h3 v-if="formData.date">{{ formatDate(new Date(formData.date)) }}</h3>
      </div>

      <div v-for="kategori in data" :key="kategori.kategori">
        <p><b>Kategori</b> {{ kategori.kategori }}</p>

        <table class="w-100" cellpadding="10">
          <thead>
            <th width="5%">Tgl</th>
            <th width="5%">NoLaporan</th>
            <th width="5%"></th>
            <th width="10%">ExCont</th>
            <th width="10%">MerkDibarang</th>
            <th width="10%">JenisBarang</th>
            <th width="15%">DeskripsiKejadian</th>
            <th width="10%">TellymanJKT</th>
          </thead>
          <tbody>
            <tr v-for="data in kategori.data" :key="data.id">
              <td>{{ formatDate2(data.tgl) }}</td>
              <td>{{ data.id }}</td>
              <td>{{ data.karyawan.nama }}</td>
              <td v-if="data.container">
                {{ data.container.no_container }}/{{ data.container.kc }} -
                {{ data.vessel.nama_kapal }} Voy: {{ data.vessel.voy }}
              </td>
              <td>{{ data.ttb.penerima_detil.nama }}</td>
              <td>
                <ul>
                  <li v-for="ttbDetil in data.ttb.ttb_detil" :key="ttbDetil.id">
                    {{ ttbDetil.koli }} {{ ttbDetil.packing }}
                    {{ ttbDetil.nama_barang }}
                  </li>
                </ul>
              </td>
              <td>{{ data.deskripsi_kejadian }}</td>
              <td v-if="data.container">
                {{ data.container.petugas_stuffing }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </main>

    <!-- Print Button -->
    <v-btn
      class="mx-2"
      fab
      dark
      right
      bottom
      fixed
      color="success"
      v-if="!state.noData && !state.loading"
      @click="printDocument"
    >
      Print
    </v-btn>
  </div>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      state: {
        loading: false,
        noData: true
      },
      formData: {
        date: ""
      },
      data: {},
      months: [
        "Januari",
        "Februari",
        "Maret",
        "April",
        "Mei",
        "Juni",
        "Juli",
        "Agustus",
        "September",
        "Oktober",
        "November",
        "Desember"
      ],
      days: ["Minggu", "Senin", "Selasa", "Rabu", "Kamis", "Jumat", "Sabtu"]
    };
  },
  methods: {
    printDocument() {
      window.print();
    },
    async fetchData() {
      this.state.loading = true;

      await axios
        .get(`laporan-kejadian?tgl=${this.formData.date}`)
        .then(res => {
          this.data = res.data;

          if (res.data.length == 0) {
            this.state.noData = true;
          } else {
            this.state.noData = false;
          }

          this.state.loading = false;
        })
        .catch(err => {
          this.state.loading = false;

          alert(err.response.data.message);
        });
    },
    formatDate(val) {
      let date = new Date(val);
      let day = date.getDay();
      let month = date.getMonth();
      let year = date.getFullYear();

      return `${this.days[day]}, ${date.getDate()} ${
        this.months[month]
      } ${year}`;
    },
    formatDate2(date) {
      const newDate = new Date(date);

      return `${String(newDate.getDate()).padStart(2, "0")}-${String(
        newDate.getMonth() + 1
      ).padStart(2, "0")}-${newDate.getFullYear()}`;
    }
  }
};
</script>

<style lang="css" scoped>
.report {
  background-color: white;
  width: 100%;
  font-family: times;
  padding: 20px;
  color: black;
}

.report .report-title {
  border-bottom: 1px solid black;
}

.header {
  display: flex;
  justify-content: space-between;
}

.header .left {
  width: 80%;
}

.header .right {
  width: 20%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.right p {
  font-size: 12px;
}

.report-info {
  display: flex;
  margin-top: 1rem;
  justify-content: space-between;
}

.report-info p {
  font-style: italic;
}

.report-info .kv {
  padding: 0 5px;
  height: fit-content;
  border: 1px solid black;
}

p {
  margin: 0;
}

table {
  margin-bottom: 1rem;
  font-size: 13px;
}

table ul {
  padding: 0;
  margin: 0;
  list-style: none;
}

table th {
  text-align: left;
}

table td,
table th {
  padding: 0 5px;
}

footer {
  display: flex;
  justify-content: space-between;
}

.sign p {
  margin-right: 150px;
}

.header {
  border: 2px solid black;
  border-left: none;
  border-right: none;
  margin-bottom: 0.5rem;
}
</style>
